import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
export default function NowMintingCountdownSoldOut() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-pointer-events-none tw-absolute tw-inset-x-6 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-white/0 tw-via-white/15 tw-to-white/0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-mt-0.5 tw-flex tw-h-9 tw-w-9 md:tw-h-10 md:tw-w-10 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-success/10 tw-ring-1 tw-ring-success/20"><CheckCircleIcon className="tw-size-5 tw-text-success/80 tw-flex-shrink-0" /></span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-black/40 tw-p-4 md:tw-p-5 tw-text-left tw-shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)]">{t0}<div className="tw-flex tw-items-start tw-gap-4">{t1}<div className="tw-flex tw-flex-col tw-gap-2"><span className="tw-text-base tw-font-semibold tw-text-success">Mint complete</span><span className="tw-text-sm tw-leading-relaxed tw-text-iron-100">All NFTs have been successfully minted.</span><span className="tw-text-xs tw-text-iron-400">Thank you for participating.</span></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}